import { useEffect, useState } from "react";
import classNames from "classnames";

import styles from "./tabs.module.scss";
export default function Tabs({ tabs = [], defaultTab }: { tabs: any[]; defaultTab?: string }) {
  // const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);

  const [activeTab, setActiveTab] = useState<string>("");

  // Initialize from hash or default tab
  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (hash && tabs.some((t) => t.id === hash)) {
      setActiveTab(hash);
    } else {
      setActiveTab(defaultTab || tabs[0]?.id);
    }

    // Listen for back/forward navigation
    const handleHashChange = () => {
      const newHash = window.location.hash.replace("#", "");
      if (tabs.some((t) => t.id === newHash)) {
        setActiveTab(newHash);
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, [tabs, defaultTab]);

  const handleTabClick = (tabId: string) => {
    setActiveTab(tabId);
    window.location.hash = tabId; // updates URL and triggers history
    const el = document.querySelector(`[data-tab-id="${tabId}"]`);
    el?.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
  };

  return (
    <div className={styles["tabs-container"]}>
      {/* --- Tabs Header --- */}
      <div className={styles["tabs-header"]}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            data-tab-id={tab.id}
            className={classNames(styles["tab-button"], { [styles["active"]]: activeTab === tab.id })}
            onClick={() => handleTabClick(tab.id)}
          >
            {tab.icon && <tab.icon size={18} />}
            {tab.label}
          </button>
        ))}
      </div>

      {/* --- Tabs Content --- */}
      <div className={styles["tabs-content"]}>
        {tabs.map(
          (tab) =>
            activeTab === tab.id && (
              <div key={tab.id} className={styles["tabs-panel"]}>
                {typeof tab.content === "function" ? tab.content() : tab.content}
              </div>
            ),
        )}
      </div>
    </div>
  );
}
